import router from './router';
import store from './store';
import Vue from 'vue';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { confirmRequiredEmails } from '@/utils/required-email-notice';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/dingHours']; // no redirect whitelist 没有重定向白名单

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();
  // set page title
  document.title = getPageTitle(to.name);
  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' });
      NProgress.done(); // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through get Info
      const HAS_PERMISSIONS = store.getters.userPermissions && store.getters.userPermissions.length > 0;
      if (HAS_PERMISSIONS) {
        next();
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          await store.dispatch('user/getInfo');

          const USER_PERMISSIONS = store.getters.userPermissions;
          if (USER_PERMISSIONS.length == 0) {
            throw new Error('The account has not been assigned a role. Please contact the administrator.');
          }
          // generate accessible routes map based on roles
          // TODO: 把菜单的权限 传入异步路由生成
          const accessRoutes = await store.dispatch('permission/generateRoutes', USER_PERMISSIONS);
          // console.log(accessRoutes);
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          setTimeout(() => {
            next({ ...to, replace: true });
          }, 50);
        } catch (error) {
          // remove token and go to login page to re-login
          // 删除令牌并转到登录页面重新登录
          // await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error');
          setTimeout(async () => {
            await store.dispatch('user/logout');
            next(`/login?redirect=${to.path}`);
            NProgress.done();
          }, 1000);
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(async (to) => {
  // finish progress bar
  NProgress.done();
  setTimeout(() => {
    document.title = ' '; // 先清空标题
    document.title = getPageTitle(to.name); // 再设置新标题
  }, 100);
  if (whiteList.indexOf(to.path) === -1 && getToken() && store.getters.cusId) {
    // 先渲染首页或原目标页面，再显示通知，避免弹窗背后出现空白。
    await Vue.nextTick();
    if (router.currentRoute.fullPath !== to.fullPath || !getToken() || !store.getters.cusId) return;
    await confirmRequiredEmails();
  }
});
